import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DocumentsComponent, DocumentsService, GungModalService, DocumentsEditModalComponent } from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { first } from 'rxjs';
import { TyloDocumentsUploadModalComponent } from '../tylo-documents-upload-modal/tylo-documents-upload-modal.component';

@Component({
  selector: 'tylo-tylo-documents',
  templateUrl: './tylo-documents.component.html',
  styleUrls: ['./tylo-documents.component.css']
})
export class TyloDocumentsComponent extends DocumentsComponent {
  constructor(
    documentsService: DocumentsService,
    modalService: NgbModal,
    gungModalService: GungModalService,
    translationService: TranslateService,
    dateUtilService: DateUtilService
  ) {
    super(documentsService, modalService, gungModalService, translationService, dateUtilService);
  }

  openUploadModal() {
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };

    const modalRef = this.modalService.open(TyloDocumentsUploadModalComponent, config);
    modalRef.componentInstance.multiple = true;
    modalRef.componentInstance.uploadMethodExt = (
      file,
      fileDescription,
      inMenu,
      showInDocumentView,
      userGroups,
      includedAssortments,
      includedCustomers,
      excludedCustomers
    ) =>
      this.uploadFileExt(
        file,
        fileDescription,
        inMenu,
        showInDocumentView,
        userGroups,
        includedAssortments,
        includedCustomers,
        excludedCustomers
      );
    modalRef.result.then(
      result => {
        if (result === true) {
          this.initDocuments(true);
        }
      },
      reason => {
        console.log(`Dismissed ${reason}`);
      }
    );
  }

  uploadFileExt(
    files: File[],
    fileDescription: string,
    inMenu: boolean = false,
    showInDocumentView: boolean = false,
    userGroups: any,
    includedAssortments: string,
    includedCustomers: string,
    excludedCustomers: string
  ): Promise<boolean> {
    const formData = new FormData();
    for (const file of files) {
      formData.append('documents', file);
    }
    formData.append('inMenu', inMenu.toString());
    formData.append('showInDocumentView', showInDocumentView.toString());
    formData.append('description', fileDescription);
    formData.append('language', this.translationService.currentLang);
    formData.append('userGroups', JSON.stringify(userGroups));
    formData.append('includedAssortments', includedAssortments);
    formData.append('includedCustomers', includedCustomers);
    formData.append('excludedCustomers', excludedCustomers);

    return new Promise((resolve, reject) => {
      this.documentsService
        .uploadDocument(formData)
        .pipe(first())
        .subscribe(
          (event: any) => {
            if (typeof event === 'object') {
              if (event.filenames) {
                resolve(true);
              }
            }
          },
          error => {
            reject(error);
          }
        );
    });
  }

  editFileExt(
    documentId,
    fileDescription: string,
    inMenu: boolean = false,
    userGroups: any,
    includedAssortments: string,
    includedCustomers: string,
    excludedCustomers: string
  ): Promise<boolean> {
    const metadata = {
      inMenu,
      description: fileDescription,
      language: this.translationService.currentLang,
      userGroups: JSON.stringify(userGroups),
      includedAssortments,
      includedCustomers,
      excludedCustomers
    };

    return new Promise((resolve, reject) => {
      this.documentsService
        .editDocument(documentId, metadata)
        .pipe(first())
        .subscribe(
          (event: any) => {
            if (typeof event === 'object') {
              if (event.filenames) {
                resolve(true);
              }
            }
          },
          error => {
            reject(error);
          }
        );
    });
  }

  editDocument(document) {
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    const modalRef = this.modalService.open(DocumentsEditModalComponent, config);
    modalRef.componentInstance.document = document;
    modalRef.componentInstance.multiple = true;
    modalRef.componentInstance.editMethod = (
      documentId,
      fileDescription,
      inMenu,
      userGroups,
      includedAssortments,
      includedCustomers,
      excludedCustomers
    ) =>
      this.editFileExt(
        documentId,
        fileDescription,
        inMenu,
        userGroups,
        includedAssortments,
        includedCustomers,
        excludedCustomers
      );
    modalRef.result.then(
      result => {
        if (result === true) {
          this.initDocuments(true);
        }
      },
      reason => {
        console.log(`Dismissed ${reason}`);
      }
    );
  }
}
